import axiosInstance from "../../utils/axiosInstance";

const videoService = {

    getList: async (page = 1, pageSize = 10, search = "") => {

        const response = await axiosInstance.get("/Video", {
            params: {
                page,
                pageSize,
                search
            }
        });

        return response.data;
    },

    getById: async (id) => {

        const response = await axiosInstance.get(`/Video/${id}`);

        return response.data;
    },

    create: async (data) => {

        const response = await axiosInstance.post(
            "/Video",
            data
        );

        return response.data;
    },

    update: async (id, data) => {

        const response = await axiosInstance.put(
            `/Video/${id}`,
            data
        );

        return response.data;
    },

    delete: async (id) => {

        const response = await axiosInstance.delete(
            `/Video/${id}`
        );

        return response.data;
    }

};

export default videoService;